<template>
    <a class="news-link f-cb" :href="path">
        <div class="col-r f-fr" v-if="imgUrl">
            <div :class="{'img-wrap': true, 'inApp': inApp}">
                <div class="img" :data-src="imgUrl"></div>
                <i class="icon icon-video-play" v-if="item.type == 3"></i>
            </div>
        </div>
        <div class="col-l">
            <div class="title-wrap">
                <div class="title f-toe2">
                    {{item.title}}
                </div>
            </div>
            <div class="info f-toe1">
                <span class="catg f-toe1" v-if="item.category">{{item.category}}</span
                ><span class="source f-toe1" v-if="item.source">{{item.source}}</span
                ><span class="time">{{timestamp | dateFormat2}}</span>
            </div>
        </div>
    </a>
</template>

<script>
import {artTypes, inApp} from 'common/constant';
import newsItemMixin from 'common/mixin/news-item';
import Jt from 'common/util/jt';

export default {
    mixins: [newsItemMixin],
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            inApp: inApp
        }
    },
    computed: {
        imgUrl() {
            const imgUrl = this.item.imgUrl;
            if(imgUrl) {
                const images = imgUrl.split(',http');
                return images[0];
            }
            return '';
        }
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.col-l {
    .title-wrap {
        height: 56px;
        margin-bottom: 3px;
    }
    .title {
        line-height: 1.5;
        color: rgba(0, 0, 0, 1);
        font-size: 13px;
    }
    .info {
        color: rgba(0, 0, 0, 0.3);
        font-size: 11px;
        line-height: 14px;
        .catg, .source {
            max-width: 0.6rem;
            margin-right: 0.06rem;
        }
        span {
            display: inline-block;
            vertical-align: middle;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
.col-r {
    margin-left: 0.06rem;
    .img-wrap {
        position: relative;
        width: 105px;
        height: 75px;
        // background: url('../../image/placeholder.png') center center no-repeat;
        background-color: #f6f6f6;
        background-size: contain;
        &.en {
            // background-image: url('../../image/placeholder_en.png');
        }
    }
    .img {
        width: 100%;
        height: 100%;
        background: center center no-repeat;
        background-size: 100% 100%;
    }
    .icon-video-play {
        position: absolute;
        width: 42px;
        height: 42px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url('../../image/ic_details_play_normal.png') no-repeat center center;
        background-size: contain;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/component/news-stream/news-tpl-4.vue